const escapeRegExp = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/**
 * Appends ` | {brand}` to a page title unless the title already names the
 * brand as a whole word, so titles like "konfetti – Erlebnisse …" don't end in
 * "| konfetti" too, while "Konfettikanone basteln" still gets the suffix.
 */
export const withBrandSuffix = (
  title: string | null | undefined,
  brand: string
): string => {
  if (!title) return brand
  // No lookbehind: Safari before 16.4 throws on it.
  const brandAsWord = new RegExp(
    `(?:^|[^\\p{L}\\p{N}])${escapeRegExp(brand)}(?![\\p{L}\\p{N}])`,
    'iu'
  )
  if (brandAsWord.test(title)) return title
  return `${title} | ${brand}`
}
